var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72827 0C10.4382 0 13.4558 2.95111 13.4558 6.57919C13.4558 8.2909 12.7841 9.85208 11.6849 11.0238L13.8478 13.1345C14.0503 13.3325 14.051 13.6527 13.8485 13.8507C13.7477 13.9507 13.6143 14 13.4817 14C13.3497 14 13.2171 13.9507 13.1155 13.852L10.9265 11.7173C9.775 12.6191 8.31495 13.1591 6.72827 13.1591C3.01836 13.1591 0 10.2073 0 6.57919C0 2.95111 3.01836 0 6.72827 0ZM6.72827 1.01343C3.5897 1.01343 1.03629 3.50985 1.03629 6.57919C1.03629 9.64853 3.5897 12.1456 6.72827 12.1456C9.86615 12.1456 12.4196 9.64853 12.4196 6.57919C12.4196 3.50985 9.86615 1.01343 6.72827 1.01343Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b4db75a1de0025d424d87c206f94eae6.svg";
export { ForwardRef as ReactComponent };